import { style } from "@vanilla-extract/css";

export const routeFallback = style({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
